import React, { useState } from "react";
import { BsBorderCenter, BsBorderWidth } from "react-icons/bs";
import ContactUs from "../components/ContactUs";
import AboutHeader from "../components/layout/header/AboutHeader";
import Footer from "../components/layout/Footer";
const About = () => {
  const [contactModal, setContactModal] = useState(false);

  const clickHandler = () => {
    setContactModal(!contactModal);
  };

  return (
    <div>
      <AboutHeader />
      {/* <div style={{ padding: '5rem 0' }}>
      <div className='text-center my-5'>
        <h1>This is About page.</h1>
        <button className='btn btn-primary mx-auto' onClick={clickHandler}>
          Contact Us
        </button>
        {contactModal && <ContactUs contactModal={setContactModal} />}
      </div>
    </div> */}

      <div className="container-fluid pt-md-4 pb-5 mt-md-5 mb-5">
        <div className="row me-md-5 pe-md-5 justify-content-center align-items-md-center">
          {/* <div style={{width: "5rem", height: "5rem", backgroundColor: "orange", zIndex: "-1"}} className="col-12">

          </div> */}
          <div className="col-md-6 ">
            <div
              class="card rounded-0 py-md-5 align-items-center cardDropdown ms-md-5"
              style={{
                width: "100%",
                // height: "100%",
                // marginLeft: "20%",
                // position: "absolute",
                zIndex: "5",
                boxShadow: " 0 4px 4px 0 rgba(0, 0, 0, 0.25)",
              }}
            >
              <div class="card-body">
                <h2 class="card-title fw-bold pb-md-3">Vision & Mission</h2>
                <p class="card-text">
                  To make KIBI Sports a centralized digital platform for{" "}
                  <br></br>
                  sports learning and sports profession. We consider our{" "}
                  <br></br>
                  vision is fulfilled when there will be no hesitation to{" "}
                  <br></br>
                  take sports as a career. Our mission It is to provide all{" "}
                  <br></br>
                  in one solution for everything related to sports
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <img
              style={
                {
                  // width: "43.9rem",
                  // height: "26.4rem",
                  // position: "relative",
                }
              }
              src="/assests/arrow_img.jpeg"
              alt="Game Picture"
              className="img-fluid centerDropdown"
            />
          </div>
        </div>
        {/* <br/><br/>
        <div className="container">
          <div className="left">
            <div className="content">
              <p>
                {" "}
                To make KIBI Sports a centralized digital platform for <br></br>
                sports learning and sports profession. We consider our <br></br>
                vision is fulfilled when there will be no hesitation to{" "}
                <br></br>
                take sports as a career. Our mission It is to provide all{" "}
                <br></br>
                in one solution for everything related to sports
              </p>
            </div>
          </div>
          <div className="right"></div>
        </div> */}
        <div className="d-flex justify-content-center py-5 my-md-5">
          <h2 className="fw-bold">
            We are Creating a digital Sports ecosystem
          </h2>
        </div>

        <div
          className="row pe-md-5 "
          style={{
            background:
              'url("/assests/baseball_img.jpeg") no-repeat center center/cover',
          }}
        >
          <div className="d-flex">
            <div
              className="row col-md-6 py-5 secondNews2 ms-auto "
              style={{ paddingLeft: "5%", zIndex: "2" }}
            >
              <p className="py-5 mx-0">
                We are creating a sports digital ecosystem A place where our
                <br></br>
                <span className="ps-md-2">
                  &nbsp;customers can learn grow and support in sports.We
                  provide
                </span>
                <br></br>
                <span className="ps-md-5 ms-md-4">
                  &nbsp; &nbsp;a plethora of services ranging tutorials, events
                  and
                </span>
                <br></br>
                <span className="ps-md-1">
                  information, turf bookings and scout funding for atheletes as
                </span>
                <br></br>
                well. An Athlete stakes buying and stakes betting platform for
                <br></br>
                <span className="ps-md-2">
                  all sports leagues and sports events happening around. Our
                </span>
                <br></br>
                <span className="ps-md-5">
                  application strives to provide a platform to connect the
                </span>{" "}
                <br></br>
                <span className="d-flex justify-content-center ps-md-5 ms-md-5">
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  &nbsp;sports playing community of India.
                </span>
              </p>
            </div>
            <div style={{}} className="secondNews2Border my-5"></div>
          </div>
        </div>

        <div className="my-md-5 py-5 text-center">
          <h1 style={{ color: "#432344" }} className="fw-bold m-0 p-0">
            IMPACTING FUTURE STARS
          </h1>
          <br></br>
          <h2 className="p-0 m-0 lh-1">from a young age.</h2>
        </div>
        <div className="d-md-flex justify-content-between mx-md-5 px-5 my-md-5">
          <p style={{ color: "#545558" }}>
            An athlete's journey begins from school where they <br></br>
            get several small yet significant platforms to<br></br>
            showcase their talent. But the success rate of <br></br>
            transforming an athelete who shows potential at a<br></br>
            school level into the finest athlete on the world stage<br></br>
            is alarmingly low. This is what KIBI Sports want to solve <br></br>
            by creating awareness and projecting the benefits <br></br>
            around sports from a grassroot level. This will enable <br></br>
            us to impact future stars from a young age in a <br></br>
            nuturing bubble.
          </p>
          <p style={{ color: "#545558" }}>
            Best deals, best price, best quality products in the <br></br>
            internet. We are providing a wide range of products as <br></br>
            per your sporting needs at your fingertips.<br></br>
            <br></br>
            Apparel manufacturing: Customise your clothing and <br></br>
            flaunt your team in style. Choose from a variety of <br></br>
            fabric, collar type, sleeve type. print type, design, <br></br>
            colors, all in all including free shipping!
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
